import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useBillDetailSettingsSchema = () => {
  const { t } = useTranslation();

  return z.object({
    newDisplayName: z.string().min(1, {
      message: t(
        "editMeterSettingsModal.form.fields.name.validations.required",
      ),
    }),
    newFactoryNumber: z.string().optional(),
    newOptionalDeclaration: z.boolean(),
  });
};
